const paymethodCheckbox = document.getElementById('paymethod');

// Function to check for variantOption and execute logic
function checkForVariantOption() {
  const variantOption = document.querySelector('[aria-label="20%"]');

  if (paymethodCheckbox && variantOption) {
    // Clear the interval once the element is found
    clearInterval(checkInterval);

    paymethodCheckbox.parentElement.style.opacity = 1;
    // Check if the variant option is selected
    if (variantOption.getAttribute('aria-checked') === 'true') {
      paymethodCheckbox.checked = true;

      // Optional: trigger the change logic if needed
      document.querySelector('[orig-value="20%"]')?.click();
    }

    // Add change event listener
    paymethodCheckbox.addEventListener('change', function () {
      if (this.checked) {
        document.querySelector('[orig-value="20%"]')?.click();
      } else {
        document.querySelector('[orig-value="100%"]')?.click();
      }
      setTimeout(function () {
        if (document.querySelector('.lite-upload-body')) {
          document.querySelector('.lite-upload-body').style.display = "block";
        }
      }, 200);
    });
  }
}

// Set an interval to check for variantOption every 100ms
const checkInterval = setInterval(checkForVariantOption, 100);

// Optional: Set a timeout to prevent infinite checking (e.g., after 10 seconds)
setTimeout(() => {
  clearInterval(checkInterval);
  console.warn('variantOption not found after 10 seconds');
}, 10000);


  

document.addEventListener("DOMContentLoaded", function () {
  const toggleLinks = document.querySelectorAll(".more_full_details");

  toggleLinks.forEach(function (toggleLink) {
    const detailsBlock = toggleLink.nextElementSibling;

    if (detailsBlock && detailsBlock.classList.contains("more_details_block")) {
      toggleLink.addEventListener("click", function (e) {
        e.preventDefault();

        const isVisible = detailsBlock.style.display === "block";

        if (isVisible) {
          detailsBlock.style.display = "none";
          toggleLink.classList.remove("open");
        } else {
          detailsBlock.style.display = "block";
          toggleLink.classList.add("open");
        }
      });
    } else {
      console.warn("Next element is not a '.more_details_block'.");
    }
  });

   const scrollLink = document.querySelector('a[href="#top"]');

  if (scrollLink) {
    scrollLink.addEventListener('click', function (event) {
      event.preventDefault(); // prevent default jump
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
  
});

document.addEventListener("cart:change", () => {
  console.log("cart change");
});

document.addEventListener("facet:update", async (event) => {
  setTimeout(function() {
    // Get the full query string
  const queryString = window.location.search;

  // Create URLSearchParams object
  const urlParams = new URLSearchParams(queryString);

  // Get specific query parameter values
  const productpage = urlParams.get('page');     // "123"
    if(productpage != 1)
    {
      const hide_description = document.querySelector(".hide_description");
      if(hide_description)
      {
        hide_description.style.display="none";
      }
    }
  }, 1500);
  console.log(event);
});
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    // Find the swatch-option1 block
    const swatchWrapper = document.querySelector("#swatch-option1");

    if (swatchWrapper) {
      const swatchLabel = swatchWrapper.querySelector(".swatch-option-name");
      
      if (swatchLabel && swatchLabel.textContent.toLowerCase().includes("size")) {
        if (!swatchWrapper.querySelector(".custom-size-message")) {
          const message = document.createElement("div");
          message.className = "custom-size-message";
          message.innerHTML = `
            <p style="margin-top:10px;font-size:14px;">You need another size? <a href="${Shopify.routes.root}pages/contact" style="text-decoration:underline;">Contact us</a></p>
          `;
          const swatchView = swatchWrapper.querySelector(".swatch-view.swatch-view-button");
          if (swatchView) {
            swatchView.insertAdjacentElement("afterend", message);
          }
        }
      }
    }
  }, 2000);
});
